// 261010 UI2-SCRIPT — danh sách chương của hộp "New Film Plan" (THUẦN, không antd). Dựng MỘT lần (useMemo ở FilmArea) thay vì mỗi lần vẽ lại một mảng mới.
import type { SourceChapter } from '../../types';
import { CHAPTER_USED_SUFFIX } from './filmCreatePlanLabels';

export interface ChapterOption { value: string; label: string; disabled: boolean }

/** `minOrder` = orderIndex của chương "From" (−1 = chưa chọn ⇒ tất cả). Chương đã nằm trong plan khác ⇒ khoá + "(đã dùng)". */
export function chapterOptionsOf(chapters: Pick<SourceChapter, 'id' | 'orderIndex' | 'name'>[], usedIds: ReadonlySet<string>, minOrder: number): ChapterOption[] {
  return chapters
    .filter((c) => c.orderIndex >= minOrder)
    .map((c) => {
      const used = usedIds.has(c.id);
      return { value: c.id, disabled: used, label: `#${c.orderIndex}${c.name ? ` — ${c.name}` : ''}${used ? CHAPTER_USED_SUFFIX : ''}` };
    });
}
